import React from 'react';
import Heading from '@amzn/meridian/heading';
import Text from '@amzn/meridian/text';
import Row from '@amzn/meridian/row';
import Tooltip from '@amzn/meridian/tooltip';
import Box from '@amzn/meridian/box';
import infoKnockoutTokens from '@amzn/meridian-tokens/base/icon/info-knockout';
import Icon from '@amzn/meridian/icon';
import { chainWalk } from '../../utils/helpers';
import { Column } from '@amzn/meridian';

const CubeView = ({ adherenceData, selectedCycle }) => {
  const cubeData = chainWalk(
    () =>
      adherenceData['timeWindowAdherences']
        .filter((adherence) => adherence['activeShifts'].includes(selectedCycle) && adherence['type'] === 'cube')
        .sort(
          (firstAdherence, secondAdherence) =>
            secondAdherence.timeWindow.startInSeconds - firstAdherence.timeWindow.startInSeconds
        )[0].processAdherences,
    {}
  );

  const overallData = chainWalk(
    () => cubeData.filter((data) => data.entityAttrs.label === 'overall')[0].actual.toFixed(2),
    '-'
  );
  const arrivedData = chainWalk(
    () => cubeData.filter((data) => data.entityAttrs.label === 'arrived')[0].actual.toFixed(2),
    '-'
  );
  const inductedData = chainWalk(
    () => cubeData.filter((data) => data.entityAttrs.label === 'inducted')[0].actual.toFixed(2),
    '-'
  );
  const stowedData = chainWalk(
    () => cubeData.filter((data) => data.entityAttrs.label === 'stowed')[0].actual.toFixed(2),
    '-'
  );

  return (
    <Box type="outline" spacingInset="400">
      <Heading level={2} type="h300" alignment="left" className="overview-fph">
        Cube
        <Tooltip position="end" title="for the selected cycle">
          <Icon className={'custom-tool-tip'} tokens={infoKnockoutTokens} />
        </Tooltip>
      </Heading>
      <Row width="100%" alignmentVertical="top">
        <Column spacing="50" alignmentVertical="center">
          <Text type="d50">{overallData}</Text>
          <Text type="b100">Total</Text>
        </Column>
        <Column spacing="50" alignmentVertical="center">
          <Text type="d50">{arrivedData}</Text>
          <Text type="b100">Pending Induct</Text>
        </Column>
        <Column spacing="50" alignmentVertical="center">
          <Text type="d50">{inductedData}</Text>
          <Text type="b100">Pending Stow</Text>
        </Column>
        <Column spacing="50" alignmentVertical="center">
          <Text type="d50">{stowedData}</Text>
          <Text type="b100">Pending Depart</Text>
        </Column>
      </Row>
    </Box>
  );
};

export default CubeView;
